import { FastshiftUserDetailsExpectedError } from '@wac-web/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client.types';

import { SourceKey } from '@/analytics/constants';

/**
 * Determines the correct analytics source key based on user details error state
 * @param userDetailsError - The error state from fastshift user details
 * @returns The corresponding analytics source key
 */
export const getSourceKeyFromError = (userDetailsError: string | null): SourceKey => {
	switch (userDetailsError) {
		case FastshiftUserDetailsExpectedError.NO_ELIGIBLE_LICENSE:
			return SourceKey.FASTSHIFT_PORTAL_INELIGIBLE_NO_LICENSE_SCREEN;
		case FastshiftUserDetailsExpectedError.NO_ACCESS:
			return SourceKey.FASTSHIFT_PORTAL_INELIGIBLE_NO_ACCESS_SCREEN;
		default:
			return SourceKey.FASTSHIFT_PORTAL_GENERIC_ERROR_SCREEN;
	}
};
